import React from 'react';
import './LineBox.css';
import bricks from './images/middleBricks.png'

function LineBox({ onClick, totalBoxes, checkBox, label }) {
    const w = 80.0 / totalBoxes;
    const space = (totalBoxes > 21 ? 6.0 : 10.0) / totalBoxes;

    // Determine state class
    let stateClass = '';
    let icon = null;
    let iconClassName = 'box-icon';

    switch (checkBox) {
        case "correct":
            icon = "✅";
            stateClass = "state-correct";
            break;
        case "target":
            icon = "⏹️";
            stateClass = "state-target";
            break;
        case "left":
            icon = "➡️";
            stateClass = "state-left";
            iconClassName = "box-icon slide-right-animation";
            break;
        case "right":
            icon = "⬅️";
            stateClass = "state-right";
            iconClassName = "box-icon slide-left-animation";
            break;
        default:
            break;
    }

    return (
        <div
            className={`line-box ${stateClass}`}
            role="button"
            aria-label={label}
            style={{
                width: `${w}%`,
                height: "100px",
                margin: `0 ${space}%`,
                backgroundImage: `url(${bricks})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
            }}
            onClick={onClick}
        >
            {checkBox !== null && icon !== null && (
                <div className={iconClassName}>
                    {icon}
                </div>
            )}
        </div>
    );
}

export default LineBox;
